import { useState } from 'react';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { cancelAgendaItem, fetchMyAgenda } from 'modules/jogador/agenda/agendaService';
import { AgendaItem } from 'modules/jogador/agenda/types';

export function useMyAgenda() {
  const { data: items, isLoading, error, setData: setItems } = useAsyncData<AgendaItem[]>(fetchMyAgenda, []);
  const [confirmingId, setConfirmingId] = useState<string | null>(null);

  function requestCancel(id: string) {
    setConfirmingId(id);
  }

  function dismissCancel() {
    setConfirmingId(null);
  }

  function confirmCancel(id: string) {
    setItems((prev) => prev.map((item) => (item.id === id ? { ...item, status: 'cancelado' } : item)));
    setConfirmingId(null);
    cancelAgendaItem(id).catch(() => {});
  }

  return { items, isLoading, error, confirmingId, requestCancel, dismissCancel, confirmCancel };
}
